import React, { Component } from 'react';
import { getUser } from '../helpers/user';
import { Redirect, Route, RouteProps, withRouter, RouteComponentProps } from 'react-router-dom';

class Authenticated extends Component<RouteProps & RouteComponentProps<any>> {
    render() {
        const user = getUser();
        if (!user) {
            let redir = this.props.location.pathname;
            if (this.props.location.search) {
                redir += '?' + this.props.location.search;
            }
            return <Redirect
                to={{
                    pathname: "/login",
                    state: { redir: redir }
                }} />
        }
        return <Route {...this.props}>
            {this.props.children}
        </Route>
    }
}

export default withRouter(Authenticated)
